/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Navbar configuration for challenge and hub pages.
 * @export
 * @interface PageNavbarConfig
 */
export interface PageNavbarConfig {
    /**
     * Navbar background color (hex code, e.g.,
     * @type {string}
     * @memberof PageNavbarConfig
     */
    backgroundColor?: string;
    /**
     * Text color for logo, headings, labels
     * @type {string}
     * @memberof PageNavbarConfig
     */
    textColor?: string;
    /**
     * Icon button color (live, info, invite)
     * @type {string}
     * @memberof PageNavbarConfig
     */
    iconColor?: string;
    /**
     * Bottom border color (hex code)
     * @type {string}
     * @memberof PageNavbarConfig
     */
    borderColor?: string;
    /**
     * Whether to show bottom border (default true)
     * @type {boolean}
     * @memberof PageNavbarConfig
     */
    borderVisible?: boolean;
    /**
     * Asset ID for custom avatar when user has none
     * @type {string}
     * @memberof PageNavbarConfig
     */
    customAvatarImageId?: string;
    /**
     * CDN URL for custom avatar (in response)
     * @type {string}
     * @memberof PageNavbarConfig
     */
    customAvatarImageUrl?: string;
    /**
     * Whether to show the countdown timer
     * @type {boolean}
     * @memberof PageNavbarConfig
     */
    showTimer?: boolean;
    /**
     * Position of the timer in navbar
     * @type {string}
     * @memberof PageNavbarConfig
     */
    timerPosition?: PageNavbarConfigTimerPositionEnum;
    /**
     * Timer text color override
     * @type {string}
     * @memberof PageNavbarConfig
     */
    timerColor?: string;
    /**
     * Epoch ms — countdown timer target date in navbar
     * @type {number}
     * @memberof PageNavbarConfig
     */
    countdownTargetDate?: number;
    /**
     * CSS gradient for a 4px accent bar below the header (e.g. "linear-gradient(90deg,
     * @type {string}
     * @memberof PageNavbarConfig
     */
    accentBarGradient?: string;
    /**
     * On mobile, pin nav to top (default) or bottom of the screen
     * @type {string}
     * @memberof PageNavbarConfig
     */
    mobileNavStyle?: PageNavbarConfigMobileNavStyleEnum;
}


/**
 * @export
 */
export const PageNavbarConfigTimerPositionEnum = {
    left: 'left',
    center: 'center',
    right: 'right'
} as const;
export type PageNavbarConfigTimerPositionEnum = typeof PageNavbarConfigTimerPositionEnum[keyof typeof PageNavbarConfigTimerPositionEnum];

/**
 * @export
 */
export const PageNavbarConfigMobileNavStyleEnum = {
    top: 'top',
    bottom: 'bottom'
} as const;
export type PageNavbarConfigMobileNavStyleEnum = typeof PageNavbarConfigMobileNavStyleEnum[keyof typeof PageNavbarConfigMobileNavStyleEnum];


/**
 * Check if a given object implements the PageNavbarConfig interface.
 */
export function instanceOfPageNavbarConfig(value: object): value is PageNavbarConfig {
    return true;
}

export function PageNavbarConfigFromJSON(json: any): PageNavbarConfig {
    return PageNavbarConfigFromJSONTyped(json, false);
}

export function PageNavbarConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageNavbarConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'backgroundColor': json['backgroundColor'] == null ? undefined : json['backgroundColor'],
        'textColor': json['textColor'] == null ? undefined : json['textColor'],
        'iconColor': json['iconColor'] == null ? undefined : json['iconColor'],
        'borderColor': json['borderColor'] == null ? undefined : json['borderColor'],
        'borderVisible': json['borderVisible'] == null ? undefined : json['borderVisible'],
        'customAvatarImageId': json['customAvatarImageId'] == null ? undefined : json['customAvatarImageId'],
        'customAvatarImageUrl': json['customAvatarImageUrl'] == null ? undefined : json['customAvatarImageUrl'],
        'showTimer': json['showTimer'] == null ? undefined : json['showTimer'],
        'timerPosition': json['timerPosition'] == null ? undefined : json['timerPosition'],
        'timerColor': json['timerColor'] == null ? undefined : json['timerColor'],
        'countdownTargetDate': json['countdownTargetDate'] == null ? undefined : json['countdownTargetDate'],
        'accentBarGradient': json['accentBarGradient'] == null ? undefined : json['accentBarGradient'],
        'mobileNavStyle': json['mobileNavStyle'] == null ? undefined : json['mobileNavStyle'],
    };
}

export function PageNavbarConfigToJSON(json: any): PageNavbarConfig {
    return PageNavbarConfigToJSONTyped(json, false);
}

export function PageNavbarConfigToJSONTyped(value?: PageNavbarConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'backgroundColor': value['backgroundColor'],
        'textColor': value['textColor'],
        'iconColor': value['iconColor'],
        'borderColor': value['borderColor'],
        'borderVisible': value['borderVisible'],
        'customAvatarImageId': value['customAvatarImageId'],
        'customAvatarImageUrl': value['customAvatarImageUrl'],
        'showTimer': value['showTimer'],
        'timerPosition': value['timerPosition'],
        'timerColor': value['timerColor'],
        'countdownTargetDate': value['countdownTargetDate'],
        'accentBarGradient': value['accentBarGradient'],
        'mobileNavStyle': value['mobileNavStyle'],
    };
}

